<!-- 成绩公示 大屏-->
<template>
    <div v-if="isShow" class="score-table">
        <div class="match-name">{{ title }}</div>
        <div class="title">
            <div class="title-logo">掼一把&reg; 达天下</div>
            <div class="match-info">第{{round}}轮 成绩公示表 ({{ second }}秒)</div>
            <div class="count-down-placeholder" v-if="!showCountdown"></div>
            <div class="count-down" v-else>{{ countdownTime }}</div>
        </div>
        <div class="flex-row-1">
            <el-table class="custom-table custom-table2"
                :row-class-name="tableRowClassName"
                v-if="firstTableData.length > 0"
                :data="firstTableData"
                :cell-class-name="tableCellClassName"
                 border>
                <el-table-column
                    label="东西"   
                    align="center"        
                >
                <template slot-scope="scope" >
                    <div v-if="pubType==='1'">
                        <span :class="scope.row.statusW === '弃权'? 'gray-row':''">{{ scope.row.usernameW }}</span>/<span :class="scope.row.statusE === '弃权'? 'gray-row':''">{{ scope.row.usernameE }}</span>
                    </div>
                    <div  v-else>
                        <span :class="scope.row.statusWE === '弃权'? 'gray-row':''">{{ scope.row.usernameWE }}</span>
                    </div>
                </template>
                </el-table-column>
                <el-table-column
                    prop="scoreWE"
                    label="级数"                    
                    align="center" 
                    :label-class-name="thirdTableData.length>0?'custom-table-header':''"
                    :width="thirdTableData.length>0?'40px':'80px'"
                    >
                </el-table-column>
                <el-table-column
                    prop="deskNo"
                    label="桌号"                    
                    align="center" 
                    :label-class-name="thirdTableData.length>0?'custom-table-header':''"
                    :width="thirdTableData.length>0?'40px':'80px'"
                    >
                </el-table-column>
                <el-table-column
                    prop="scoreSN"
                    label="级数"                    
                    align="center" 
                    :label-class-name="thirdTableData.length>0?'custom-table-header':''"
                    :width="thirdTableData.length>0?'40px':'80px'"
                    >
                </el-table-column>
                <el-table-column
                    label="南北"
                    align="center"     
                >
                <template slot-scope="scope">
                    <div v-if="pubType==='1'">
                        <span :class="scope.row.statusS === '弃权'? 'gray-row':''">{{ scope.row.usernameS }}</span>/<span :class="scope.row.statusN === '弃权'? 'gray-row':''">{{ scope.row.usernameN }}</span>
                    </div>
                    <div v-else>
                        <span :class="scope.row.statusSN === '弃权'? 'gray-row':''">{{ scope.row.usernameSN}}</span>
                    </div>
                </template>
                </el-table-column>  
            </el-table> 
            <el-table class="custom-table custom-table2"
                :row-class-name="tableRowClassName"
                v-if="secondTableData.length > 0"
                :data="secondTableData"
                :cell-class-name="tableCellClassName"
                style="margin-left: 10px;"
                 border>
                <el-table-column
                    label="东西"   
                    align="center"           
                >
                <template slot-scope="scope" >
                    <div v-if="pubType==='1'">
                        <span :class="scope.row.statusW === '弃权'? 'gray-row':''">{{ scope.row.usernameW }}</span>/<span :class="scope.row.statusE === '弃权'? 'gray-row':''">{{ scope.row.usernameE }}</span>
                    </div>
                    <div  v-else>
                        <span :class="scope.row.statusWE === '弃权'? 'gray-row':''">{{ scope.row.usernameWE }}</span>
                    </div>
                </template>
                </el-table-column>
                <el-table-column
                    prop="scoreWE"
                    label="级数"                   
                    align="center"  
                    :label-class-name="thirdTableData.length>0?'custom-table-header':''"
                    :width="thirdTableData.length>0?'40px':'80px'"
                    >
                </el-table-column>
                <el-table-column
                    prop="deskNo"
                    label="桌号"                   
                    align="center" 
                    :label-class-name="thirdTableData.length>0?'custom-table-header':''"
                    :width="thirdTableData.length>0?'40px':'80px'" 
                    >
                </el-table-column>
                <el-table-column
                    prop="scoreSN"
                    label="级数"
                    align="center"  
                    :label-class-name="thirdTableData.length>0?'custom-table-header':''"
                    :width="thirdTableData.length>0?'40px':'80px'"
                    >
                </el-table-column>
                <el-table-column
                    label="南北"
                    align="center"  
                >
                <template slot-scope="scope" >
                    <div v-if="pubType === '1'">
                        <span :class="scope.row.statusS === '弃权'? 'gray-row':''">{{ scope.row.usernameS }}</span>/<span :class="scope.row.statusN === '弃权'? 'gray-row':''">{{ scope.row.usernameN }}</span>
                    </div>
                    <div v-else>
                        <span :class="scope.row.statusSN === '弃权'? 'gray-row':''">{{ scope.row.usernameSN}}</span>
                    </div>
                </template>
                </el-table-column>  
            </el-table> 
            <el-table class="custom-table custom-table2"
                :row-class-name="tableRowClassName"
                v-if="thirdTableData.length>0"
                :data="thirdTableData"
                :cell-class-name="tableCellClassName"
                style="margin-left: 10px;"
                 border>
                <el-table-column
                    label="东西"   
                    align="center"           
                >
                <template slot-scope="scope" >
                    <div v-if="pubType==='1'">
                        <span :class="scope.row.statusW === '弃权'? 'gray-row':''">{{ scope.row.usernameW }}</span>/<span :class="scope.row.statusE === '弃权'? 'gray-row':''">{{ scope.row.usernameE }}</span>
                    </div>
                    <div  v-else>
                        <span :class="scope.row.statusWE === '弃权'? 'gray-row':''">{{ scope.row.usernameWE }}</span>
                    </div>
                </template>
                </el-table-column>
                <el-table-column
                    prop="scoreWE"
                    label="级数"
                    align="center" 
                    :label-class-name="thirdTableData.length>0?'custom-table-header':''"
                    :width="thirdTableData.length>0?'40px':'80px'" 
                    >
                </el-table-column>
                <el-table-column
                    prop="deskNo"
                    label="桌号"
                    align="center" 
                    :label-class-name="thirdTableData.length>0?'custom-table-header':''"
                    :width="thirdTableData.length>0?'40px':'80px'" 
                    >
                </el-table-column>
                <el-table-column
                    prop="scoreSN"
                    label="级数"
                    align="center"  
                    :label-class-name="thirdTableData.length>0?'custom-table-header':''"
                    :width="thirdTableData.length>0?'40px':'80px'"
                    >
                </el-table-column>
                <el-table-column
                    label="南北"
                    align="center"  
                >
                <template slot-scope="scope" >
                    <div v-if="pubType === '1'">
                        <span :class="scope.row.statusS === '弃权'? 'gray-row':''">{{ scope.row.usernameS }}</span>/<span :class="scope.row.statusN === '弃权'? 'gray-row':''">{{ scope.row.usernameN }}</span>
                    </div>
                    <div v-else>
                        <span :class="scope.row.statusSN === '弃权'? 'gray-row':''">{{ scope.row.usernameSN}}</span>
                    </div>
                </template>
                </el-table-column>  
            </el-table> 
        </div>      
    </div>
 </template> 
 <script>
import { mapMutations } from 'vuex'
 export default {
     data() {
         return {
            isShow: false,
            tableData: [],
            firstTableData: [],
            secondTableData: [],
            thirdTableData: [],
            second: 5,
            timer: null,
            loading: false,
            round: 1,
            pubId: '',
            pubType: '',
            showCountdown: false,
            countdownTime: '',
            countdownTimer: null,
         }
     },
     created() {
        this.pubId = this.$route.query.id
        if(this.pubId){
            this.getTitle()
            this.countDown()
            this.getTimeQuery()
        }  
     },
     mounted() {
        document.addEventListener('click', this.toggleFullScreen);
        setTimeout(()=>{
            this.initData()
        },100)
        
     },
     methods: {
        ...mapMutations(['SET_ROUND']),
        tableCellClassName({row,column, rowIndex}){
            if(column.property === 'deskNo' && row.games === 111){
                return 'green-row'
            }
        },
        tableRowClassName({row, rowIndex}){
            // 一桌一种颜色
            if(row.deskNo % 2){
                return 'white-row'
            }else{
                return  'light-green-row'
            }
        },
         // 分数查询
         initData(){
            let params = {
                opcode: this.$code.ScoreNotice,
                i_serial_mark: this.pubId,
                i_round: this.round,
                i_games_id: 0,
                i_desk_no: 0
             }
             this.$api.requestAPI(params).then(res =>{
                 if (res.IsSuccess) {
                    let result = res.Data.DataTable
                    this.isShow = true
                    if(result.length > 0) {                        
                        let newArr   = result.map(item=>{
                        let username = this.pubType === '2'? `${item['选手名称']}/${item['搭档名称']}` : item['选手名称']
                         return{
                            deskNo: item['桌号'],
                            id: item['选手编号'],
                            username: username,
                            phone: item['选手手机号'],
                            company: item['协会（俱乐部）'],
                            userId: item['选手账号'],
                            seat: item['座位'],
                            round: item['第几轮'],
                            score: item['成绩'],
                            partner: item['搭档名称'],
                            games: item['局数'],
                            status: item['状态']
                         }
                     })
                    this.tableData = this.selectDeskNoNew(newArr)
                    let  playerArr  = JSON.parse(JSON.stringify(this.tableData))
                        if(playerArr.length > 20){
                            if(playerArr.length > 46){
                                const chunkSize =  Math.ceil(playerArr.length / 3)
                                const chunkedArrays = this.splitArrayIntoChunks(playerArr, chunkSize);
                                this.firstTableData = chunkedArrays[0]
                                this.secondTableData = chunkedArrays[1]
                                this.thirdTableData = chunkedArrays[2]
                        
                            }else{
                                const splitSize = Math.round(playerArr.length / 2); 
                                this.firstTableData = playerArr.slice(0, splitSize);  
                                this.secondTableData = playerArr.slice(splitSize);
                                this.thirdTableData = []
                            }
                        }else{
                            this.firstTableData = playerArr
                            this.secondTableData = []
                        }
                        // console.log(playerArr.length) 
                       
                    }else{
                        this.isShow = true
                        this.tableData = []
                        this.firstTableData = []
                        this.secondTableData = []
                        this.thirdTableData = []
                        this.$message.error('请到编排界面，点击编排按钮！')
                        this.stopCountdown()
                    }                   
                 }
             }).catch(err=>{
                this.stopCountdown()
             })
            },
        // 创建一个函数来均分数组
        splitArrayIntoChunks(array, chunkSize){
            const chunks = [];
            for (let i = 0; i < array.length; i += chunkSize) {
                chunks.push(array.slice(i, i + chunkSize));
            }
            return chunks;
        },
         selectDeskNo(arr){
            let result = []
            arr.forEach(item => {
                 if(!result.some(i => i.deskNo === item.deskNo )){
                        let newArr = arr.filter(user => user.deskNo === item.deskNo)
                        
                        let usernameWE = ''
                        let usernameSN = ''
                        if(this.pubType === '1'){
                            usernameWE = (newArr.filter(i =>  i.seat.includes('东')))[0].username +'/'+ (newArr.filter(i =>  i.seat.includes('西')))[0].username
                            usernameSN = (newArr.filter(i =>  i.seat.includes('南')))[0].username +'/'+ (newArr.filter(i =>  i.seat.includes('北')))[0].username
                        }else{
                            usernameWE = (newArr.filter(i =>  i.seat.includes('东')))[0].username 
                            usernameSN = (newArr.filter(i =>  i.seat.includes('北')))[0].username
                        }                       
                        result.push({
                            deskNo: item.deskNo,
                            scoreWE: (newArr.filter(i =>  i.seat.includes('东')))[0].score,
                            scoreSN: (newArr.filter(i =>  i.seat.includes('北')))[0].score,
                            games: item.games,
                            statusWE:(newArr.filter(i =>  i.seat.includes('东')))[0].status,
                            statusSN:(newArr.filter(i =>  i.seat.includes('北')))[0].status,
                            usernameWE: usernameWE,
                            usernameSN: usernameSN,
                        })
                 }
             });
             return result
        }, 
        
        // 桌号和分数
        selectDeskNoNew(arr){
            let result = []
            arr.forEach(item => {
                 if(!result.some(i => i.deskNo === item.deskNo )){
                        let newArr = arr.filter(user => user.deskNo === item.deskNo)
                        let usernameW = (newArr.filter(i =>  i.seat.includes('东')))[0].username 
                        let usernameE = (newArr.filter(i =>  i.seat.includes('西')))[0].username
                        let usernameS = (newArr.filter(i =>  i.seat.includes('南')))[0].username
                        let usernameN = (newArr.filter(i =>  i.seat.includes('北')))[0].username
                        let scoreW = (newArr.filter(i =>  i.seat.includes('东')))[0].score
                        let scoreE = (newArr.filter(i =>  i.seat.includes('西')))[0].score
                        let scoreS = (newArr.filter(i =>  i.seat.includes('南')))[0].score
                        let scoreN = (newArr.filter(i =>  i.seat.includes('北')))[0].score    
                        let scoreWE = ''
                        let scoreSN= ''
                        let statusWE = ''
                        let statusSN = ''
                        let usernameWE = ''
                        let usernameSN = ''
                        if(this.pubType === '1'){
                            if(scoreW === '弃' && scoreE === '弃')  {
                                scoreWE = scoreW
                            }else if(scoreW === '弃' && scoreE !== '弃'){
                                scoreWE = scoreE
                            }else if(scoreW !== '弃' && scoreE === '弃'){
                                scoreWE =  scoreW
                            }else if(scoreW !== '弃' && scoreE !== '弃'){
                                scoreWE = scoreW
                            } 
                            if(scoreS === '弃' && scoreN === '弃')  {
                                scoreSN = scoreS
                            }else if(scoreS === '弃' && scoreN !== '弃'){
                                scoreSN = scoreN
                            }else if(scoreS !== '弃' && scoreN === '弃'){
                                scoreSN =  scoreS
                            }else if(scoreS !== '弃' && scoreN !== '弃'){
                                scoreSN = scoreS
                            } 

                        }else{
                            scoreWE =(newArr.filter(i =>  i.seat.includes('东')))[0].score
                            scoreSN = (newArr.filter(i =>  i.seat.includes('北')))[0].score

                            statusWE = (newArr.filter(i =>  i.seat.includes('东')))[0].status
                            statusSN =(newArr.filter(i =>  i.seat.includes('北')))[0].status  

                            usernameWE = (newArr.filter(i =>  i.seat.includes('东')))[0].username 
                            usernameSN = (newArr.filter(i =>  i.seat.includes('北')))[0].username      
                        }                     
                        result.push({
                            deskNo: item.deskNo,                            
                            usernameW: usernameW,
                            usernameE: usernameE,
                            usernameS: usernameS,
                            usernameN: usernameN,
                            scoreWE: scoreWE,
                            scoreSN: scoreSN,                              
                            games: item.games,                        
                            statusW: (newArr.filter(i =>  i.seat.includes('东')))[0].status,
                            statusE: (newArr.filter(i =>  i.seat.includes('西')))[0].status,
                            statusS: (newArr.filter(i =>  i.seat.includes('南')))[0].status,
                            statusN: (newArr.filter(i =>  i.seat.includes('北')))[0].status,
                            statusWE: statusWE,
                            statusSN: statusSN,
                            usernameWE: usernameWE,
                            usernameSN: usernameSN,
                        })
                 }
             });
             return result
        }, 
        stopCountdown(){
            clearInterval(this.timer)
            this.timer = null
        },
        stopCountdownTimer(){
            clearInterval(this.countdownTimer)
            this.countdownTimer = null
        },
        startCountdown(timeString){
            // 清除之前的倒计时
            this.stopCountdownTimer()
            
            // 解析时间字符串，格式为分秒
            const timeParts = timeString.split(':')
            const minutes = parseInt(timeParts[0]) || 0
            const seconds = parseInt(timeParts[1]) || 0
            
            // 计算总秒数
            let totalSeconds = minutes * 60 + seconds
            
            this.showCountdown = true
            
            // 更新倒计时显示
            this.updateCountdownDisplay(totalSeconds)
            
            // 启动倒计时定时器
            this.countdownTimer = setInterval(() => {
                if (totalSeconds > 0) {
                    totalSeconds--
                    this.updateCountdownDisplay(totalSeconds)
                } else {
                    this.stopCountdownTimer()
                    this.showCountdown = false
                }
            }, 1000)
        },
        updateCountdownDisplay(seconds){
            const minutes = Math.floor(seconds / 60)
            const secs = seconds % 60
            
            // 格式化显示，只显示分和秒
            this.countdownTime = `${minutes.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`
        },
        countDown(){            
            // 清除之前可能存在的定时器
            this.stopCountdown()
            
            // 设置新的定时器
            this.timer = setInterval(()=>{
                if(this.second > 0){
                    this.second--
                }else{
                    // 重置倒计时
                    this.second = 5
                    // 刷新数据
                    this.initData()
                }
            }, 1000)
        },
        toggleFullScreen(){
            if (!document.fullscreenElement) {
                this.$help.enterFullScreen();
            } else {
                this.$help.exitFullScreen();
            }
        },  
        getTitle(){
            let params = {
                opcode: this.$code.PublishQuery,
                i_serial_mark: this.pubId,
                c_status: '',
                v_type: '',
                v_theme: '',
                start_date: '',
                end_date: '',
                pagesize: 10,
                page: 1,
            }
            this.$api._requestAPI(params).then(res =>{
                if (res.IsSuccess) {
                    let result = res.Data.DataTable
                    let list = result.map(item=>{     
                        let type = item['类型']
                        return{
                            title: item['主题'],
                            round:  item['比赛轮数']+1,
                            maxRound: item['轮数'],
                            type: type.includes('单人')? '1': '2'
                        }
                    })
                    this.title = list[0].title
                    this.round = list[0].round <= list[0].maxRound ? list[0].round : list[0].maxRound
                    this.pubType = list[0].type
                    // console.log(this.pubType,'单人双人赛',this.round)
                    this.SET_ROUND(this.round)
                }
            })
        },   
        getTimeQuery(){
            let params = {
                opcode: this.$code.TimerQuery,
                i_serial_mark: this.pubId,
            }
            this.$api._requestAPI(params).then(res=>{
                if(res.IsSuccess){
                    let list = res.Data.DataTable
                    let result = list.map(i=>{
                        return{
                            t: i['倒计时'],
                            remain: i['剩余倒计时'],
                            status: i['状态'],
                            img: i['图片'],
                            size: i['字体'],
                            color: i['颜色'],
                        }
                    })
                    if(result && result.length > 0 && result[0].t) {
                        this.startCountdown(result[0].t)
                    }
                }else{
                    this.errorMsg = res.Message
                }
            })
        },  
     },
     destroyed(){
        this.stopCountdown()  
        this.stopCountdownTimer()
    },  
     beforeDestroy() {
        this.stopCountdown()  
        this.stopCountdownTimer()
          // 在实例销毁前移除事件监听
          document.removeEventListener('click', this.toggleFullScreen);
     },
 }
 </script>
 <style lang='scss' scoped>
 @import '@/assets/css/style.scss';
 .title{
   font-size: 24px;
   text-align: center;
   color: gold;
   padding: 2px 0;
   background-color: #de2c11;
   display: flex;
   justify-content: space-around;
   align-items: center;  
 }
 .title > div{
   width: 33.33%;
   text-align: center;
 }
 .count-down-placeholder{
   width: 33.33%;
   text-align: center;
   visibility: hidden;
 }
 .title-logo{
   font-size: 24px;
   color: gold;
   font-weight: bold;
 }
 .match-info{
   font-size: 24px;
   color: gold;
   font-weight: bold;
 }
 .match-name{
   font-size: 30px;
   color: gold;
   font-weight: bold;
   text-align: center;
   background-color: #de2c11;
 }
 .count-down{
   font-size: 30px;
   color: gold;
   font-weight: bold;
 }
.el-table >>> .light-green-row{
    background-color: #bbffbb
  }
.el-table >>> .gray-row{
    background-color: #C5C7C4
  }
.el-table >>> .white-row{
    background-color: #f0f9eb;
}
.el-table >>> .green-row{
    background-color: green;
    color:#fff !important
  }
.el-table .el-table__cell {
    padding: 0 !important;
}
.custom-table >>>  .cell{
    padding: 6px 0 !important;
    font-size: 32px ;
    font-family: '黑体';
}
.custom-table >>> .el-table__header-wrapper {
    // font-size: 30px !important;
    // color: #000;
    // padding: 20px 0;
    // font-family: '黑体';    
}
.custom-table >>> .custom-table-header .cell{
    font-size: 18px !important
}
 </style>


// WEBPACK FOOTER //
// src/views/fullScreen/fullScoreRefresh.vue